import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ClientsService } from 'src/app/service/clients/clients.service';
import { AuthService } from 'src/app/service/auth/auth.service';
import { Clients } from 'src/app/models/firebase/client';
import KeenSlider, { KeenSliderInstance } from "keen-slider"
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { IMAGES_RESOLUTIONS } from 'src/app/utils/image-config';
import { SpinnerService } from '../../service/spinner/spinner.service';

const animation = { duration: 20000, easing: (t: any) => t }

@Component({
  selector: 'app-clients-brand-scroll',
  templateUrl: './clients-brand-scroll.component.html',
  styleUrls: [
    './clients-brand-scroll.component.scss'
]
})
export class ClientsBrandScrollComponent implements AfterViewInit, OnInit, OnDestroy{

    clients: Clients[] = [];
    slider: KeenSliderInstance = null;
    @Input() landingPageData: LandingPage;
    screenWidth: number;
    @ViewChild("sliderRef") sliderRef: ElementRef<HTMLElement>
    IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
    constructor(
        private clientService: ClientsService,
        private authService: AuthService,
        private spinnerService: SpinnerService
    ){
        this.getScreenSize()
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.slider = new KeenSlider(this.sliderRef.nativeElement, {
                loop: true,
                slides: {
                    perView: (this.screenWidth <= 625) ? 2 : (this.screenWidth <= 1024) ? 3 : (this.landingPageData?.clients?.list?.length > 7 ? 6 : this.landingPageData?.clients?.list?.length)
                },
                renderMode: "performance",
                drag: false,
                created(s) {
                    s.moveToIdx(5, true, animation)
                },
                updated(s) {
                    s.moveToIdx(s.track.details.abs + 5, true, animation)
                },
                animationEnded(s) {
                    s.moveToIdx(s.track.details.abs + 5, true, animation)
                },
            })
           }, 500);
    }

    async ngOnInit(): Promise<void> {
        this.clients = await this.clientService.getClients(this.authService.projectId);
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?: Event): void {
        this.screenWidth = window.innerWidth;
    }

    ngOnDestroy() {
        if (this.slider) this.slider.destroy()
      }
}
